<template>
  <Report
    v-bind="$attrs"
    :column-defs="columnDefs"
    retrieve-action="report/retrieveShifts"
    source="shifts"
    v-on="$listeners"
  />
</template>

<script>
import _ from 'lodash';
import Report from '@/components/scheduling/reports/Report';
import { dateColumn, namedValues, plainColumn, setColumn, textColumn, yesNoColumn } from '@/components/scheduling/reports/columns';

export default {
  components: {
    Report
  },
  inheritAttrs: false,
  data () {
    return {
      columnDefs: null
    };
  },
  created () {
    this.columnDefs = this.buildColumnDefs();
  },
  methods: {
    buildColumnDefs () {
      const t = key => this.$t(key);
      const org = this.$store.state.org;
      const flags = _.sortBy(org.flags.map(flag => ({ id: flag.id, shortCode: `${flag.shortCode} - ${flag.name}` })), 'shortCode');

      const columnDefs = [
        textColumn('assigneeFullName', this.$t('labels.employeeName')),
        yesNoColumn('canceled', this.$t('labels.canceled'), t),
        plainColumn('comments', this.$tc('labels.comment', 1)),
        dateColumn('date', this.$tc('labels.date', 1), t)
      ];
      if (this.$store.getters['account/isDepartmentManagement']()) {
        columnDefs.push(plainColumn('departmentName', this.$tc('labels.department', 1)));
      } else {
        columnDefs.push(setColumn('departmentName', this.$tc('labels.department', 1), namedValues(org.departments), { sortable: true }));
      }
      columnDefs.push(
        plainColumn('employeeId', this.$t('labels.employeeID')),
        plainColumn('endTime', this.$t('labels.endTime'), { sortable: true }),
        setColumn('flagShortCodes', this.$tc('labels.flag', 1), flags, { label: 'shortCode', showTooltips: true }),
        plainColumn('homeDepartmentName', this.$t('labels.homeDepartment'))
      );
      if (this.$store.getters['account/isOperationsManagement']()) {
        columnDefs.push(plainColumn('internalComments', this.$t('labels.internalComments')));
      }
      columnDefs.push(
        setColumn('jobStatusName', this.$t('labels.jobStatus'), namedValues(org.jobStatus)),
        setColumn('jobTypeName', this.$tc('labels.jobType', 1), namedValues(org.jobTypes)),
        dateColumn('payrollDate', this.$t('labels.payrollDate'), t),
        plainColumn('startTime', this.$t('labels.startTime'), { sortable: true }),
        plainColumn('totalHours', this.$t('labels.totalHours')),
        yesNoColumn('overtime', this.$t('labels.ot'), t),
        plainColumn('overtimeHours', this.$t('labels.otHours')),
        setColumn('typeName', this.$t('labels.shiftType'), namedValues(org.shiftTypes), { sortable: true }),
        yesNoColumn('sitter', this.$t('labels.sitter'), t),
        yesNoColumn('working', this.$t('labels.working'), t)
      );
      return columnDefs;
    }
  }
};
</script>
